/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Surveys_SummaryInputs */



/**
* | output |
* | --- |
* | "Independent, experienced advice and attendance for owners, charterers and buyers throughout an operation." |
*
* @param {Service_Surveys_SummaryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_surveys_summary = /** @type {((inputs?: Service_Surveys_SummaryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Surveys_SummaryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("在整个作业过程中，为船东、租家和买方提供独立而专业的咨询与现场服务。")
	return /** @type {LocalizedString} */ ("Independent, experienced advice and attendance for owners, charterers and buyers throughout an operation.")
});